import React, { Component } from 'react'
// import ChildComponent from '../ChildComponentCD_Update/ChildComponentCDM'

class LifeCylcle extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
          name : 'toto ',
          step : 1
        }
       
    }
    componentDidMount() { // methode qui ne sera activé qu'une fois le dom finit, c'est ici qu'on pourra modifier le state
     
        this.setState({
            name : this.props.name, 
            step : this.state.step +1
        })
       
    }

    componentDidUpdate(prevProps, prevState) { // deux paramètre , le props d'avant ( prevProps) et le state d'avant (prevstate)
        
        
    }

    componentWillUnmount() {
       
    }
    
    
    

    render() {
        
        return (
            
            <div className="text-center h1 text-info bg-dark m-5">
               <p>chargement {this.state.step}</p>
               <p>Nom :  {this.state.name}</p>
               
            </div>
        )
    }
}

export default LifeCylcle
